import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AnswersByType from './AnswersByType';
import './AnswersByTypeStyles.scss';
const queryClient = new QueryClient();
function AnswersByTypeIndex(props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(AnswersByType, Object.assign({}, props))));
}
export default AnswersByTypeIndex;
